module.exports = __webpack_public_path__ + "static/media/sabores.f517ab76.png";